import React, { Component } from 'react';
import { MDBSpinner } from 'mdb-react-ui-kit';

export default class Loading extends Component {
    render() {
        return (
            <div className="loading text-center">
                <MDBSpinner className='themeColor' />
            </div>
        );
    }
}

